import { useMemo } from "react";
import SelectManyItem from "./SelectManyItem";

import * as c from "./SelectManyGroupItem.module.css";

type Option = {
  id: number;
  value: string;
  isRequired: boolean;
  groupId: number | null;
  groupName: string;
};

interface SelectManyGroupItemProps {
  groupName: string;
  groupOptions: Option[];
  selectedIds: number[];
  onToggleOption: (id: number) => void;
  openDropdown: string | null;
  onDropdownToggle: (groupName: string) => void;
}

function SelectManyGroupItem({
  groupName,
  groupOptions,
  selectedIds,
  onToggleOption,
  openDropdown,
  onDropdownToggle,
}: SelectManyGroupItemProps) {
  const selectedCount = useMemo(() => {
    return groupOptions.filter((option) => selectedIds.includes(option.id)).length;
  }, [groupOptions, selectedIds]);

  const isGroupActive = selectedCount > 0;

  const handleDropdown = () => {
    onDropdownToggle(groupName);
  };

  return (
    <div className={`${c["select-many-container"]} ${isGroupActive ? c["selected"] : ""}`}>
      <div className={c["group-header"]} onClick={handleDropdown} style={{ cursor: "pointer" }}>
        <label style={{ cursor: "pointer", pointerEvents: "none" }}>
          {groupName} {selectedCount > 0 && `(${selectedCount})`}
        </label>
      </div>

      <div className={c["dropdown-options-container"]}>
        {openDropdown === groupName &&
          groupOptions.map((option) => (
            <SelectManyItem
              key={option.id}
              value={option.value}
              isSelected={selectedIds.includes(option.id)}
              onToggle={() => onToggleOption(option.id)}
              usedInMore={true}
            />
          ))}
      </div>
    </div>
  );
}

export default SelectManyGroupItem;
